import { API } from "api/index";
import makeApi, { getClient } from "api";

export const useApi = (): API => {
  const client = getClient();
  return makeApi(client);
};
